export default "__VITE_ASSET__SLYBeN0Q__"